import { checkIsAvailableForRentInFuture, generateCategoryPositionTables } from 'containers/MapDetails/utils'
import AvailabilityNotificationPopup from 'containers/MapDetails/popups/AvailabilityNotificationPopup'
import { addItemToBasket, BASKET_TYPES, extendFormToMap } from 'containers/OrderDetails/basketSlice'
import MagElement, { countBadge } from 'containers/MapDetails/MagElement'
import DetailsPopup from 'containers/MapDetails/popups/DetailsPopup'
import { selectPlaceData } from 'containers/MapDetails/placeSlice'
import PlaceTemplatePhoto from 'components/PlaceTemplatePhoto'
import WarehouseAttrPopup from '../Popups/WarehouseAttrPopup'
import { selectLocationCategories } from './locationSlice'
import GalleryPopup from 'components/popups/GalleryPopup'
import { useHistory, useParams } from 'react-router-dom'
import AutomationPopup from '../Popups/AutomationPopup'
import { useDispatch, useSelector } from 'react-redux'
import { selectFilters } from '../menu/filtersSlice'
import ArrowBtn from 'components/buttons/ArrowBtn'
import React, { useEffect, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import usePopupState from 'hooks/usePopupState'
import AdditionalText from './AdditionalText'
import { displayPrice } from 'utils/string'
// import MmRating from 'components/MmRating'
import { useReduxSelector } from 'store'
import { selectConfig } from 'appSlice'
import { v7 } from 'uuid'

interface PlaceElementProps {
  expanded?: boolean
  data: locations.Location
  placeDetailsRef?: React.RefObject<HTMLDivElement>
}

type Popups = {
  type: 'warehouse_attr' | 'automation'
} | {
  type: 'gallery'
  props: {
    index: number
  }
} | {
  type: 'details'
  props: {
    rentableType?: warehouse.RentableType
    details: any[]
    count?: number
  }
} | {
  type: 'availability'
  props: {
    name: string
    placeId: string
    groupHash: string
    variantHash: string
    companyName: string
  }
}

const PlaceElement: React.FC<PlaceElementProps> = ({ data, expanded = false, placeDetailsRef }) => {
  const categories = useReduxSelector(selectLocationCategories)
  const { placeId: placeIdParams } = useParams<{ placeId: string }>()
  const { popup, openPopup } = usePopupState<Popups>()
  const { attributes } = useSelector(selectFilters)
  const placeData = useSelector(selectPlaceData)
  const config = useSelector(selectConfig)

  const sizes = placeData?.sizes || data?.sizes
  const warehouses = placeData?.warehouses
  const _ = (placeData?.id ? placeData : (data || {})) as locations.Location
  const [selectedCategoryId, selectCategoryId] = useState(attributes?.categoryId && _.categories?.some(c => c.categoryId === attributes?.categoryId)
    ? attributes?.categoryId
    : (_.categories?.[0]?.categoryId || ''))
  const showGroups = _.displayOptions?.sizeGroups && categories[selectedCategoryId]?.rentableType === 'warehouse'
  const [selectedSizeId, selectSizeId] = useState((() => {
    const category = (
      attributes?.categoryId
        ? _.categories?.find(c => c.categoryId === attributes.categoryId)
        : undefined
    ) || _.categories?.[0]
    if (category) {
      if (showGroups) {
        return category.warehouseTypes[0]?.id
          ? _.sizeGroups.find(g => g.warehouseTypeIds.includes(category.warehouseTypes[0]?.id))?.warehouseSizeGroupId
          : ''

      } else {
        return attributes?.warehouseTypeId && category.warehouseTypes.some(type => type.id === attributes?.warehouseTypeId)
          ? attributes.warehouseTypeId
          : (category.warehouseTypes?.[0]?.id || '')
      }
    }
    return ''
  })())

  const category = selectedCategoryId
    ? _.categories?.find(c => c.categoryId === selectedCategoryId)
    : undefined
  const price = selectedSizeId && showGroups
    ? _.sizeGroups?.find(group => group.warehouseSizeGroupId === selectedSizeId)?.monthlyGrossPrice
    : category?.warehouseTypes?.find(type => type.id === selectedSizeId)?.monthlyGrossPrice_min

  const isParkingSelected = categories?.[selectedCategoryId]?.rentableType === 'parking'
  const categoryPositions = selectedCategoryId
    ? generateCategoryPositionTables(warehouses, selectedCategoryId, !isParkingSelected)
    : undefined

  const { push } = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation('map')

  useEffect(() => {
    const selectSize = (category: locations.LocationCategory) => {
      if (_.sizeGroups && _.sizeGroups.length > 0 && categories[selectedCategoryId]?.rentableType === 'warehouse') {
        selectSizeId(category.warehouseTypes[0]?.id
          ? _.sizeGroups.find(g => g.warehouseTypeIds.includes(category.warehouseTypes[0]?.id))?.warehouseSizeGroupId
          : '')

      } else {
        selectSizeId(attributes?.warehouseTypeId && category.warehouseTypes.some(type => type.id === attributes?.warehouseTypeId)
          ? attributes.warehouseTypeId
          : (category.warehouseTypes?.[0]?.id || ''))
      }
    }

    if (selectedCategoryId) {
      const category = _.categories?.find(c => c.categoryId === selectedCategoryId)
      if (category) {
        selectSize(category)
      }

    } else if (_.categories && _.categories.length > 0) {
      const category = (attributes?.categoryId
        ? _.categories?.find(c => c.categoryId === attributes?.categoryId)
        : undefined) || _.categories?.[0]
      if (category) {
        selectCategoryId(category.categoryId)
        selectSize(category)
      }
    }
  }, [_.categories, _.sizeGroups, attributes?.categoryId, attributes?.warehouseTypeId, categories, selectedCategoryId])

  const rent = (hash: string, data: basic.Form, date?: string) => {
    if (!config) return
    if (config?.blockedCart) {
      openPopup('blockedCart')

    } else {
      const identifier = v7()
      dispatch(
        addItemToBasket({
          hash,
          identifier,
          type: BASKET_TYPES.rent,
          object: data?.data?.object,
          hasOnlineAccess: data?.data?.hasOnlineAccess,
          minDate: date ? date.replace(/(\d{2})\.(\d{2})\.(\d{4})/, '$3-$2-$1') : undefined,
          image: Array.isArray(sizes)
            ? sizes.find(size => size.warehouseTypeId === data?.data?.warehouseTypeId)?.renders?.default
            : undefined,
          rentableType: data?.rentableType,
          name: data.warehouseTypeName,
          placeId: placeIdParams,
        })
      )
      push(`/order/${identifier}`)
      dispatch(extendFormToMap(false))
    }
  }

  return (
    <>
      {popup?.type === 'warehouse_attr' && <WarehouseAttrPopup body={_.place_attrs} />}
      {popup?.type === 'automation' && <AutomationPopup body={_.automation} />}
      {popup?.type === 'gallery' && <GalleryPopup initialSlide={popup.props.index} data={_.photos} />}
      {popup?.type === 'details' && <DetailsPopup
        count={popup.props?.count}
        data={popup.props?.details}
        rentableType={popup.props?.rentableType}
      />}
      {popup?.type === 'availability' && <AvailabilityNotificationPopup
        placeId={placeIdParams}
        companyName={placeData.companyName}
        groupHash={popup.props?.groupHash}
        variantHash={popup.props?.variantHash}
        name={popup.props?.name}
      />}

      <div
        ref={placeDetailsRef}
        className='placeDetails'
        data-announcement={_.isAnnouncement}>
        <div className='placeDetails__header'>
          <div className='placeDetails__header__content'>
            <div className={`objectDetails__badge ${_.constructionDate ? '--warning' : _.isAnnouncement ? '--secondary' : '--primary'}`}>
              {t(_.constructionDate ? 'theYardIsUnderConstruction' : _.isAnnouncement ? 'offer' : 'onlineRental')}
            </div>
            <h2>{_.placeName}</h2>
            <p>{_.city}, {_.street} {_.estateNumber}</p>
            {/* {typeof mm_score === 'number' && <MmRating
              number={_?.mm_score}
              action={() => {
                openPopup({ type: 'mm_score', scoreInfo: _.mm_score_info })
              }}
            />} */}
          </div>
          {!_.isAnnouncement && <div
            className='buttonGo'
            onClick={() => {
              push(`/mapdetails/${_.id}${selectedSizeId ? `?warehouseTypeId=${selectedSizeId}` : ''}`)
            }}>
            <i className='icon icon--arrow-right s24'></i>
          </div>}
        </div>

        {_.place_attrs && _.place_attrs.length > 0 && <div className='placeDetails__attributes__wrapper --border'>
          <div
            className='placeDetails__attributes'
            onClick={() => openPopup({ type: 'warehouse_attr' })}>
            {(_.place_attrs as any[]).map((item) => <div
              key={item.id}
              className='placeDetails__attribute'>
              <i className={`icon icon--${item.key}-bold`}></i>
              <span>{item.name}</span>
            </div>)}
          </div>
        </div>}

        {_.categories?.length > 0 && <div className={`placeDetails__tabs${expanded ? ' --hideable' : ''}`}>
          {_.categories.map((item, idx) => <div
            key={idx}
            className={`placeDetails__tab${item.categoryId === selectedCategoryId ? ' --selected' : ''}`}
            onClick={() => selectCategoryId(item.categoryId)}>
            {categories[item.categoryId]?.name}
          </div>)}
        </div>}

        {selectedSizeId && category && <div className={`placeDetails__sizes${expanded ? ' --hideable' : ''}`}>
          {showGroups
            ? _.sizeGroups.map((item, idx) => {
              if (!category.warehouseTypes.some(type => item.warehouseTypeIds.includes(type.id))) return null
              return (
                <div
                  key={idx}
                  className={`placeDetails__size${item.warehouseSizeGroupId === selectedSizeId ? ' --selected' : ''}`}
                  onClick={() => selectSizeId(item.warehouseSizeGroupId)}>
                  {item.name}
                </div>
              )
            })
            : _.sizes.map((item, idx) => {
              if (!category.warehouseTypes.some(type => type.id === item.warehouseTypeId)) return null
              return (
                <div
                  key={idx}
                  className={`placeDetails__size${item.warehouseTypeId === selectedSizeId ? ' --selected' : ''}`}
                  onClick={() => selectSizeId(item.warehouseTypeId)}>
                  {item.rentableType === 'warehouse'
                    ? item.sizeShortName
                    : item.name}
                </div>
              )
            })}
        </div>}

        {selectedSizeId && <div className={`placeDetails__price${expanded ? ' --hideable' : ''}`}>
          <div className='placeDetails__subtitle'>{t('costOfSelectedSize')}</div>
          <span className='--secFont'>{t('from')} {price ? displayPrice(price) : ''}</span>
          <span className='--secFont small'>/ {t('monthly')}</span>
        </div>}

        {!_.isAnnouncement && <>
          {Array.isArray(_.photos) && _.photos.length > 0
            ? <div className='placeDetails__photos'>
              {(_.photos as any[]).map((item, idx) => <img
                key={idx}
                alt=''
                src={item.public_path}
                onClick={() => {
                  openPopup({ type: 'gallery', props: { index: idx } })
                }}
              />)}
            </div>
            : <div className='placeDetails__photo--template'>
              <PlaceTemplatePhoto />
            </div>}
        </>}

        {_.isAnnouncement
          ? <div className='placeDetails__announcementFooter'>
            <ArrowBtn
              enlarged
              text={t('showPhoneNumber')}
              action={() => {
                openPopup({ type: 'announcement', placeId: _.id })
              }}
            />
          </div>
          : <div className='placeDetails__tabs__wrapper'>
            <div className='placeDetails__tabs'>
              {_?.categories?.map((item) => <span
                key={item.categoryId}
                className={`placeDetails__tab${item.categoryId === selectedCategoryId ? ' --selected' : ''}`}
                onClick={() => selectCategoryId(item.categoryId)}>
                {categories[item.categoryId]?.name}
              </span>)}
            </div>

            {category?.automation && <div
              className='placeDetails__automation'
              onClick={() => openPopup({ type: 'automation' })}>
              <div>
                {category.automation?.key === 'full-automatic' && <i className='icon icon--shield-bold'></i>}
                <span className={`${category.automation?.key === 'full-automatic' ? 'green' : ''}`}>{category.automation?.title}</span>
              </div>
              <div>{category.automation?.description}</div>
            </div>}
            {category?.important_attrs && category.important_attrs.length > 0 && <div className='placeDetails__important'>
              {category.important_attrs.map((item, idx) => <div
                key={idx}
                className='placeDetails__important__item'>
                <i className={`icon icon--${item.key === 'lock' ? 'lock-bold' : item.key}`}></i>
                <span>{item.name}</span>
              </div>)}
            </div>}

            {isParkingSelected
              ? <>
                <div className='placeDetails__list__wrapper'>
                  <div className='placeDetails__subtitle'>{t('availableSizes')}</div>
                  <div className='placeDetails__list'>
                    {categoryPositions?.map(item => <MagElement
                      key={item.hash}
                      data={item}
                      showWarehouseTypeName
                      openPopup={(type: string) => {
                        if (type === 'details') {
                          openPopup({ type: 'details', props: { details: item?.details, count: item?.free_now_to_rent_count, rentableType: item?.rentableType } })
                        } else if (type === 'availability') {
                          openPopup({ type: 'availability', props: { name: `${item?.warehouseTypeName} - ${item?.name}`, groupHash: item.data.warehouseTypeId, variantHash: item.hash } })
                        }
                      }}
                      action={(date?: string) => {
                        rent(item.hash, item, date)
                      }}
                    />)}
                  </div>
                </div>
              </>
              : <>
                {category?.attributes && category?.attributes.length > 0 && <div
                  className='placeDetails__attributes__wrapper'
                  onClick={() => openPopup({ type: 'warehouse_attr' })}>
                  <div className='placeDetails__subtitle'>{t('storageFeatures')}</div>
                  <div className='placeDetails__attributes'>
                    {category.attributes.map((item) => <div
                      key={item.id}
                      className='placeDetails__attribute'>
                      <i className={`icon icon--${item.key}-bold`}></i>
                      <span>{item.name}</span>
                    </div>)}
                  </div>
                </div>}
                <div className='placeDetails__variants__wrapper'>
                  <div className='placeDetails__subtitle'>{t('availableSizes')}</div>
                  <div className='placeDetails__variants'>
                    {(_.sizeGroups && _.sizeGroups.length > 0)
                      ? (_.sizeGroups as locations.LocationSizeGroup[])?.map(group => {
                        return <div
                          key={group.warehouseSizeGroupId}
                          className='placeDetails__variant --groups'>
                          <div className='placeDetails__variant__size'>
                            <i className='icon icon--cube' />
                            <div className='placeDetails__variant__size__rows --secFont'>
                              <div>{group.name}</div>
                              <div>{group.areaMinShortName} - {group.areaMaxShortName}</div>
                            </div>
                          </div>
                          <div className='placeDetails__variant__price'>
                            <span className='--secFont'>{group.monthlyGrossPrice ? displayPrice(group.monthlyGrossPrice) : '-'}</span>
                            <span> / {t('monthly')}</span>
                          </div>
                        </div>
                      })
                      : categoryPositions?.map(position => {
                        const { isAvailableForRentInFuture } = checkIsAvailableForRentInFuture(position?.isAvailableForRentNow, position?.for_rent)
                        return <div
                          key={position.hash}
                          className='placeDetails__variant'>
                          <div className='placeDetails__variant__size'>
                            {config?.showAvailableQuantity && <div className='amount'>
                              <div className='amount__bg'><span className={`${countBadge(position?.free_now_to_rent_count)}`}></span></div>
                              <div className='amount__desc'>{t('amount')}: {position?.free_now_to_rent_count}</div>
                            </div>}
                            <i className='icon icon--cube' />
                            <span className='--secFont'>{position?.data?.area} m<sup>2</sup></span>
                          </div>
                          <div className='placeDetails__variant__price'>
                            <span className='--secFont'>{position?.data?.monthlyGrossPrice ? displayPrice(position.data.monthlyGrossPrice) : '-'}</span>
                            <span> / {t('monthly')}</span>
                          </div>
                          <ArrowBtn
                            showArrow={false}
                            className='--gray'
                            text={t((position?.isAvailableForRentNow || isAvailableForRentInFuture)
                              ? 'see'
                              : 'notify'
                            )}
                            action={() => {
                              push(`/mapdetails/${_.id}?warehouseTypeId=${position.data?.warehouseTypeId}`)
                            }}
                          />
                        </div>
                      })}
                  </div>
                </div>
                <ArrowBtn
                  enlarged
                  showArrow
                  text={t('viewAllStorageUnits')}
                  action={() => {
                    push(`/mapdetails/${_.id}`)
                  }}
                />
              </>}

            {_.additionalDescription && <div className='placeDetails__additional__wrapper'>
              <div className='placeDetails__subtitle'>{t('description')}</div>
              <AdditionalText
                className='placeDetails'
                text={_.additionalDescription}
              />
            </div>}

            {_.companyName && <div className='placeDetails__additional__wrapper'>
              <div className='placeDetails__subtitle'>{t('aboutTheCompany')}</div>
              <AdditionalText
                className='placeDetails'
                text={_.companyName}
              />
            </div>}
          </div>}
      </div>
    </>
  )
}

export default PlaceElement